import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class TableCollapsible extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    const { open } = this.props;
    const { isOpen } = this.state;
    if (open && open !== isOpen) {
      this.setIsOpen(open);
    }
  }

  setIsOpen = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  render() {
    const { trigger, classParentString, children, colSpan } = this.props;
    const { isOpen } = this.state;
    const classParent = classParentString ? `${classParentString}__` : '';

    return (
      <>
        <tr
          className={classnames(classParentString, { isOpen: isOpen })}
          aria-expanded={isOpen}
          tabIndex='0'
          onClick={this.setIsOpen}
          onKeyDown={this.setIsOpen}
        >
          {trigger}
          <td
            className={`${classParent}trigger`}
            // eslint-disable-next-line
            role='button'
            onClick={this.setIsOpen}
          />
        </tr>
        <tr>
          <td colSpan={colSpan}>
            <div
              className={classnames(`${classParent}contentOuter`, {
                isOpen: isOpen
              })}
            >
              <div className={`${classParent}contentInner`}>{children}</div>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

TableCollapsible.propTypes = {
  trigger: PropTypes.any.isRequired,
  classParentString: PropTypes.string,
  children: PropTypes.any.isRequired,
  colSpan: PropTypes.number.isRequired,
  open: PropTypes.bool
};

TableCollapsible.defaultProps = {
  classParentString: null,
  open: false
};

export default TableCollapsible;
